export default __webpack_public_path__ + "static/media/close.81b2658f.svg";